import React from 'react';

const Tooltip = () =>
  <div id="tooltip" className="hidden">
    <p><span id="value"></span></p>
  </div>

export default Tooltip



// WEBPACK FOOTER //
// ./src/Home/Network/Tooltip.js